import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import PaymentListPage from './PaymentListPage';
// import './PaymentListPage.less';

export const prefix = 'bm-p-payment-list';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: PaymentListPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
